import React from "react";
import info_small from '../../assets/images/info/s.svg';
import info_medium from '../../assets/images/info/m.svg';
import info_large from '../../assets/images/info/l.svg';

const InfoIconHover = ({ content, size, headline=null }) => {

    var info_icon = info_medium
    if (size === "s") {
        info_icon = info_small
    } else if (size == "l") {
        info_icon = info_large
    }

    return (
        <div>
            <img className="info-icon" src={info_icon} alt="info icon" />
            <div className="info-hover" style={{width: "300px"}}>
                {headline ? <span className="font-small semibold">{headline}</span> : ""}
                <span className="font-small">{content}</span>
            </div>
        </div>
    );
};

export default InfoIconHover;